import React from 'react';
import PropTypes from 'prop-types';
import * as buttonStyles from '../styles/styles.module.scss';
import Key from 'types/Key';

const SubmitButton = ({ text, handler, variant, classes, dataTestId = '', disabled }) => {
  const onKeyPress = event => {
    if (event.key === Key.Enter) {
      handler();
    }
  };

  return (
    <div
      className={`${buttonStyles[variant]} ${classes}`}
      onKeyPress={!disabled && onKeyPress}
      onClick={!disabled && handler}
      tabIndex="0"
      role="button"
      data-testid={dataTestId}
      disabled={disabled}
    >
      {text}
    </div>
  );
};

SubmitButton.defaultProps = {
  text: 'submit',
  handler: () => {},
  variant: 'submit',
  classes: '',
  disabled: false
};

SubmitButton.propTypes = {
  text: PropTypes.node,
  handler: PropTypes.func,
  variant: PropTypes.string,
  classes: PropTypes.string,
  disabled: PropTypes.bool
};

export default SubmitButton;
